// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smses .card-with-chat-messages .chat-messages-header {
  border: 1px solid rgba(140, 140, 140, 0.35);
  padding: 4px;
  margin-bottom: 4px;
}
.smses .card-with-chat-messages .chat-messages-header .chat-messages-header-col {
  display: flex;
}
.smses .card-with-chat-messages .chat-messages-header .chat-messages-header-col .chat-messages-header-col-title {
  font-size: 18;
  font-weight: 500;
}
.smses .card-with-chat-messages .chat-messages-header .chat-messages-header-col .ant-btn-link {
  padding-left: 0 !important;
}
.smses .card-with-chat-messages .chat-messages-header .chat-messages-header-col-right {
  display: flex;
  justify-content: flex-end;
}
.smses .card-with-chat-messages .chat-messages-header .chat-messages-header-col-right .message-search {
  max-width: 250px;
}
.smses .card-with-chat-messages .messages-scrollable-div {
  border: 1px solid rgba(140, 140, 140, 0.35);
  overflow: auto;
  display: flex;
  flex-direction: column-reverse;
  height: 100%;
}
.smses .card-with-chat-messages .messages-scrollable-div .messages-infinite-scroll {
  display: flex;
  flex-direction: column-reverse;
}
.smses .card-with-chat-messages .messages-scrollable-div .messages-infinite-scroll .chat-list-item {
  flex-direction: column;
  border: none;
}
.smses .card-with-chat-messages .messages-scrollable-div .messages-infinite-scroll .chat-list-item .message-cover {
  display: flex;
  flex-direction: column;
}
.smses .card-with-chat-messages .messages-scrollable-div .messages-infinite-scroll .chat-list-item .message-cover .message-text {
  white-space: break-spaces;
  word-break: break-word;
}
.smses .card-with-chat-messages .messages-scrollable-div .messages-infinite-scroll .chat-list-item .message-cover .message-image-elm {
  max-width: 500px;
  max-height: 800px;
  overflow: auto;
  margin-top: 8px;
  border: 1px solid rgba(140, 140, 140, 0.35);
  border-radius: 5px;
}
.smses .card-with-chat-messages .messages-scrollable-div .messages-infinite-scroll .chat-list-item .chat-list-item-div-right,
.smses .card-with-chat-messages .messages-scrollable-div .messages-infinite-scroll .chat-list-item .chat-list-item-div-left {
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  padding: 8px;
}
.smses .card-with-chat-messages .messages-scrollable-div .messages-infinite-scroll .chat-list-item .chat-list-item-div-right {
  align-self: end;
  margin: 0 10px 0 200px;
}
.smses .card-with-chat-messages .messages-scrollable-div .messages-infinite-scroll .chat-list-item .chat-list-item-div-right .chat-list-item-div-date {
  align-self: end;
}
.smses .card-with-chat-messages .messages-scrollable-div .messages-infinite-scroll .chat-list-item .chat-list-item-div-left {
  align-self: start;
  margin: 0 200px 0 10px;
}
.smses .card-with-chat-messages .messages-scrollable-div .messages-infinite-scroll .chat-list-item .chat-list-item-div-left .chat-list-item-div-date {
  align-self: start;
}
.smses .card-with-chat-messages .send-text-area-part {
  margin-top: 4px;
  border: 1px solid rgba(140, 140, 140, 0.35);
  padding-right: 77px;
}
.smses .card-with-chat-messages .send-text-area-part .send-text-area {
  margin-bottom: 21px;
}
.smses .card-with-chat-messages .send-text-area-part .ant-col {
  position: relative;
}
.smses .card-with-chat-messages .send-text-area-part .ant-col .ant-input {
  resize: none;
  width: 100%;
}
.smses .card-with-chat-messages .send-text-area-part .ant-col .send-message-button {
  position: absolute;
  right: -72px;
  top: 38px;
}
.smses .card-with-chat-messages .send-text-area-part .ant-col .upload-photo-button {
  position: absolute;
  right: -36px;
  top: 38px;
}
.smses .card-with-chat-messages .send-text-area-part .ant-col .ant-upload-list-text-container {
  border-top: 1px solid rgba(140, 140, 140, 0.35);
}
`, "",{"version":3,"sources":["webpack://./src/components/smses/sms-messages/chat-messages-area/styles.less"],"names":[],"mappings":"AAAA;EAGM,2CAAA;EACA,YAAA;EACA,kBAAA;AADN;AAJA;EAQQ,aAAA;AADR;AAPA;EAWU,aAAA;EACA,gBAAA;AADV;AAXA;EAgBU,0BAAA;AAFV;AAdA;EAqBQ,aAAA;EACA,yBAAA;AAJR;AAlBA;EAyBU,gBAAA;AAJV;AArBA;EA+BM,2CAAA;EACA,cAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;AAPN;AA5BA;EAsCQ,aAAA;EACA,8BAAA;AAPR;AAhCA;EA0CU,sBAAA;EACA,YAAA;AAPV;AApCA;EA8CY,aAAA;EACA,sBAAA;AAPZ;AAxCA;EAkDc,yBAAA;EACA,sBAAA;AAPd;AA5CA;EAuDc,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,2CAAA;EACA,kBAAA;AARd;AApDA;;EAkEY,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;AAVZ;AA3DA;EAyEY,eAAA;EACA,sBAAA;AAXZ;AA/DA;EA6Ec,eAAA;AAXd;AAlEA;EAkFY,iBAAA;EACA,sBAAA;AAbZ;AAtEA;EAsFc,iBAAA;AAbd;AAzEA;EA8FM,eAAA;EACA,2CAAA;EACA,mBAAA;AAlBN;AA9EA;EAmGQ,mBAAA;AAlBR;AAjFA;EAuGQ,kBAAA;AAnBR;AApFA;EA0GU,YAAA;EACA,WAAA;AAnBV;AAxFA;EA+GU,kBAAA;EACA,YAAA;EACA,SAAA;AApBV;AA7FA;EAqHU,kBAAA;EACA,YAAA;EACA,SAAA;AArBV;AAlGA;EA2HU,+CAAA;AAtBV","sourcesContent":[".smses {\n  .card-with-chat-messages {\n    .chat-messages-header {\n      border: 1px solid rgba(140, 140, 140, 0.35);\n      padding: 4px;\n      margin-bottom: 4px;\n\n      .chat-messages-header-col {\n        display: flex;\n\n        .chat-messages-header-col-title {\n          font-size: 18;\n          font-weight: 500;\n        }\n\n        .ant-btn-link {\n          padding-left: 0 !important;\n        }\n      }\n\n      .chat-messages-header-col-right {\n        display: flex;\n        justify-content: flex-end;\n\n        .message-search {\n          max-width: 250px;\n        }\n      }\n    }\n\n    .messages-scrollable-div {\n      border: 1px solid rgba(140, 140, 140, 0.35);\n      overflow: auto;\n      display: flex;\n      flex-direction: column-reverse;\n      height: 100%;\n\n      .messages-infinite-scroll {\n        display: flex;\n        flex-direction: column-reverse;\n\n        .chat-list-item {\n          flex-direction: column;\n          border: none;\n\n          .message-cover {\n            display: flex;\n            flex-direction: column;\n\n            .message-text {\n              white-space: break-spaces;\n              word-break: break-word;\n            }\n\n            .message-image-elm {\n              max-width: 500px;\n              max-height: 800px;\n              overflow: auto;\n              margin-top: 8px;\n              border: 1px solid rgba(140, 140, 140, 0.35);\n              border-radius: 5px;\n            }\n          }\n\n          .chat-list-item-div-right,\n          .chat-list-item-div-left {\n            display: flex;\n            flex-direction: column;\n            border-radius: 5px;\n            padding: 8px;\n          }\n\n          .chat-list-item-div-right {\n            align-self: end;\n            margin: 0 10px 0 200px;\n\n            .chat-list-item-div-date {\n              align-self: end;\n            }\n          }\n\n          .chat-list-item-div-left {\n            align-self: start;\n            margin: 0 200px 0 10px;\n\n            .chat-list-item-div-date {\n              align-self: start;\n            }\n          }\n        }\n      }\n    }\n\n    .send-text-area-part {\n      margin-top: 4px;\n      border: 1px solid rgba(140, 140, 140, 0.35);\n      padding-right: 77px;\n\n      .send-text-area {\n        margin-bottom: 21px;\n      }\n\n      .ant-col {\n        position: relative;\n\n        .ant-input {\n          resize: none;\n          width: 100%;\n        }\n\n        .send-message-button {\n          position: absolute;\n          right: -72px;\n          top: 38px;\n        }\n\n        .upload-photo-button {\n          position: absolute;\n          right: -36px;\n          top: 38px;\n        }\n\n        .ant-upload-list-text-container {\n          border-top: 1px solid rgba(140, 140, 140, 0.35);\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
